import { useRef, useEffect } from 'react';

/**
 * This hook is used to imitate componentDidUpdate logic
 * unlike regular useEffect this one won't run on component initialization
 * @param effect
 * @param dependencies
 */
const useDidUpdateEffect = (effect: () => any, dependencies: any[]) => {
  const firstUpdate = useRef(true);
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }

    effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
};

export default useDidUpdateEffect;
